import { ChangeDetectionStrategy, Component, inject, Input } from '@angular/core';
import { ITileConfig } from '@shared/components/interfaces/tile.interface';
import { Router } from '@angular/router';
import { TileTypeNavigationEnum } from '@shared/enums/tile-type-navigation.enum';
import { AdditionalTabNameEnum } from '@shared/enums/additional-tab-name.enum';
import { OnboardingService } from '@shared/services/onboarding/onboarding.service';
import { IAuth } from '@modules/login/login.component';
import { SessionService } from '@core/services/session.service';

@Component({
  selector: 'app-tile',
  templateUrl: './tile.component.html',
  styleUrls: ['./tile.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TileComponent {
  private router: Router = inject(Router);
  private onboardingService: OnboardingService = inject(OnboardingService);
  private sessionService: SessionService = inject(SessionService);

  @Input() public config: ITileConfig;
  @Input() public isFeatureStorePage: boolean = false;
  @Input() public tabIndexToReturn: number;
  @Input() public category: string;

  public navigateTo(): void {
    const auth: IAuth = this.sessionService.auth;

    let queryParams: Record<string, null | number | undefined | string | boolean> = {
      tab_index_to_return: this.tabIndexToReturn,
    };

    if (this.config.navigationType === TileTypeNavigationEnum.FEATURE) {
      queryParams = {
        ...queryParams,
        configuration: this.config.configuration,
        feature_id: this.config.id,
        feature_name: this.config.title,
      };
    } else if (this.config.navigationType === TileTypeNavigationEnum.APP) {
      queryParams = { ...queryParams };
    }

    if (auth) {
      if (this.config.is_onboarding_track) {
        this.router.navigate(['/home/apc/setcard/', this.config.id]);

        return;
      }
    }

    this.router.navigate([this.config.urlNavigateTo], { queryParams });
  }

  public isBeta(): boolean {
    if (!this.config.tags) {
      return false;
    }

    // For now we require that beta be the first tag on the feature
    return this.config.tags[0].toLocaleLowerCase() === 'beta';
  }

  public get isEnabledFeatureCategoryTab(): boolean {
    return this.category === AdditionalTabNameEnum.ENABLED_FEATURES;
  }
}
